import { AccountManager, BrkfstAccount } from 'shared/typings/account';

export interface ChatFilterOption<Value = string> {
  label: string;
  value: Value;
  selected: boolean;
}

export interface ChannelFilterValues {
  allBrands: ChatFilterOption<Pick<BrkfstAccount, 'id' | 'name'>>[];
  accountManagers: ChatFilterOption<AccountManager>[];
  search: string;
}

export const defaultChannelFilterValues: ChannelFilterValues = {
  allBrands: [],
  accountManagers: [],
  search: '',
};
